import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WritableDraft } from "immer";

import { RootState } from "@tdp/core";
import { IMetric, IMetricData } from "@tdp/modules/apps"

import { AnalyticsV1Keys } from "../abstractions";


export interface IAnalyticsActiveUsersPayload {
  isLoadingCompleted: boolean;
  hasFailed?: boolean;
  data?: IMetric[];
}

export interface IAnalyticsMetricPayload {
  isLoadingCompleted: boolean;
  hasFailed?: boolean;
  data?: IMetricData;
}

export type IAnalyticsMetricsState = Record<string, {
  [AnalyticsV1Keys.ActiveUsers]?: IAnalyticsActiveUsersPayload;
  [AnalyticsV1Keys.Metrics]?: IAnalyticsMetricPayload;
}>;

const initialState: IAnalyticsMetricsState = {};

const dataLoading = (key: AnalyticsV1Keys) => (state: WritableDraft<IAnalyticsMetricsState>, { payload }: PayloadAction<{
  appId: string,
}>) => ({
  ...state,
  [payload.appId]: {
    ...state[payload.appId],
    [key]: {
      isLoadingCompleted: false
    }
  }
});

const getMetricsDataSuccess = (key: AnalyticsV1Keys) => (state: WritableDraft<IAnalyticsMetricsState>, { payload }: PayloadAction<{
  appId: string,
  metricsData: IMetricData
}>) => ({
  ...state,
  [payload.appId]: {
    ...state[payload.appId],
    [key]: {
      data: payload.metricsData,
      isLoadingCompleted: true
    }
  }
});

const getActiveUserDataSuccess = (key: AnalyticsV1Keys) => (state: WritableDraft<IAnalyticsMetricsState>, { payload }: PayloadAction<{
  appId: string,
  activeUserData: IMetric[]
}>) => ({
  ...state,
  [payload.appId]: {
    ...state[payload.appId],
    [key]: {
      data: payload.activeUserData,
      isLoadingCompleted: true
    }
  }
});

const getDataFailed = (key: AnalyticsV1Keys) => (state: WritableDraft<IAnalyticsMetricsState>, { payload }: PayloadAction<{
  appId: string,
}>) => ({
  ...state,
  [payload.appId]: {
    ...state[payload.appId],
    [key]: {
      isLoadingCompleted: true,
      hasFailed: true
    }
  }
});

export const analyticsV1MetricsSlice = createSlice({
  name: 'analyticsV1MetricsData',
  initialState,
  reducers: {
    activeUserDataLoading: dataLoading(AnalyticsV1Keys.ActiveUsers),
    getActiveUserDataSuccess: getActiveUserDataSuccess(AnalyticsV1Keys.ActiveUsers),
    getActiveUserDataFailed: getDataFailed(AnalyticsV1Keys.ActiveUsers),
    metricsDataLoading: dataLoading(AnalyticsV1Keys.Metrics),
    getMetricsDataSuccess: getMetricsDataSuccess(AnalyticsV1Keys.Metrics),
    getMetricsDataFailed: getDataFailed(AnalyticsV1Keys.Metrics)
  }
});

export const selectMetricsDataPayload = (state: RootState, appId: string) => {
  if (appId) {
    return state.analyticsV1MetricsData[appId] ? state.analyticsV1MetricsData[appId][AnalyticsV1Keys.Metrics] : null;
  }
  return null;
}

export const selectActiveUserDataPayload = (state: RootState, appId: string) => {
  if (appId) {
    return state.analyticsV1MetricsData[appId] ? state.analyticsV1MetricsData[appId][AnalyticsV1Keys.ActiveUsers] : null;
  }
  return null;
}




